import { Vue } from 'vue-class-component';

import ProductsUtils from './ProductsUtils';
import { process, DataResult, State, SortDescriptor } from '@progress/kendo-data-query';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _, { filter, forEach } from 'lodash';
import { GridPageChangeEvent, GridSortChangeEvent, GridDataStateChangeEvent } from '@progress/kendo-vue-grid';

import OrdersSearchService from '../services/OrdersSearchService';

import { resources } from '../resources';

export default class MyAccountProductsList extends Vue {
    @Prop(String)
    public languageId: string = 'it-IT';

    @Prop(Number)
    public accountId: number = 0;

    public productsData: DataResult | null = null;

    public listColumns: any[] | null = null;

    public sort: SortDescriptor[] = [
        { field: 'name', dir: 'asc' }
    ];

    public pageable: boolean = true;
    public sortable: boolean = true;

    public skip: number = 0;
    public take: number = 10;
    public total: number = 0;

    public resources = resources;

    public searchIsLoading: boolean = true;

    private products: any[] = [];

    private searchService: OrdersSearchService | null = null;

    onPageChanged(e: GridPageChangeEvent) {
        this.skip = e.page.skip;

        this.bindData();

        this.pushSearchHistory();
    };

    onSortChanged(e: GridSortChangeEvent) {
        this.sort = e.sort;

        this.doSort();

        this.pushSearchHistory();
    }

    doSort() {
        this.products = ProductsUtils.orderBy(this.products, this.sort);

        this.bindData();
    }

    private pushSearchHistory(): void {
        var instance = this;

        // build query string
        var page: number = instance.getPageIndex() + 1;

        // page
        var querystring = `?page=${page}`;

        // order by
        if (instance.sort.length > 0) {
            var orderBySerialized = ProductsUtils.getOrderByQueryStringParam(instance.sort);
            querystring += `&orderby=${orderBySerialized}`;
        }

        history.pushState(null, '', location.pathname + querystring);
    }

    private rebuildFiltersFromHistoryState() {
        var instance = this;

        // set defaults
        instance.skip = 0;
        instance.sort = [
            { field: 'sku', dir: 'asc' }
        ];

        if (location.search && location.search != '') {
            var urlParams = new URLSearchParams(location.search);

            urlParams.forEach((value: string, key: string) => {
                if (!value || value == '')
                    return;

                switch (key.toLowerCase()) {
                    case "page":
                        var pageNumber = Number(value);

                        if (pageNumber != NaN) {
                            instance.skip = (pageNumber - 1) * instance.take;
                        }

                        break;

                    case "orderby":
                        var sortByQueryString = ProductsUtils.getSortByOrderByQueryStringParam(value);

                        instance.sort.splice(0, instance.sort.length);
                        instance.sort.push.apply(instance.sort, sortByQueryString);

                        break;
                }
            });
        }
    }

    private getPageIndex(): number {
        return (this.take > 0 ? this.skip / this.take : 0);
    }

    private fetchData(thisSearchId: number | null) {
        var instance = this;

        var pathAndQueryString = (location.pathname + location.search);

        instance.searchService?.searchOrdersProducts(instance.accountId, instance.languageId, null, null, pathAndQueryString)
            .then((res: any) => {
                var thisProducts = res.results.items;
                instance.total = res.results.totalCount as number;

                if (!instance.products) {
                    instance.products = [];
                }

                if (instance.products.length > 0) {
                    instance.products.splice(0, instance.products.length);
                }

                instance.products.push.apply(instance.products, thisProducts);

                if (!instance.listColumns) {
                    var thisColumns = res.columns as any[];

                    // add "addToCart" column
                    thisColumns.push({
                        title: '',
                        cell: 'addToCart'
                    });

                    var nameCol = _.find(thisColumns, (c) => c.field == 'name');
                    if (nameCol)
                        nameCol.cell = 'designation'

                    var priceCol = _.find(thisColumns, (c) => c.field == 'sellingPrice');
                    if (priceCol)
                        priceCol.cell = 'sellingPrice'

                    instance.listColumns = thisColumns;
                }

                // apply binding with client sorting
                instance.doSort();

                instance.searchIsLoading = false;
            });
    }

    private bindData(): void {
        var thisProducts = ProductsUtils.page(this.products || [], this.skip, this.take);

        const dataState = {};

        this.productsData = process(thisProducts, dataState);
    }

    onHistoryPopState(event: PopStateEvent) {
        var instance = this;

        instance.rebuildFiltersFromHistoryState();
        instance.doSort();
    }

    created() {
        this.searchService = new OrdersSearchService();

        this.rebuildFiltersFromHistoryState();

        // show loader only in first search
        this.searchIsLoading = true;

        this.fetchData(null);

        window.addEventListener('popstate', this.onHistoryPopState);
    }
}